import { render, staticRenderFns } from "./verResolucion.vue?vue&type=template&id=507612ec&scoped=true"
import script from "./verResolucion.vue?vue&type=script&lang=js"
export * from "./verResolucion.vue?vue&type=script&lang=js"
import style0 from "./verResolucion.vue?vue&type=style&index=0&id=507612ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507612ec",
  null
  
)

export default component.exports